import { render, staticRenderFns } from "./outwardcar.vue?vue&type=template&id=0bfff24b&scoped=true&"
import script from "./outwardcar.vue?vue&type=script&lang=js&"
export * from "./outwardcar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfff24b",
  null
  
)

export default component.exports